import { PopoverMenuComponent } from 'commons/components';
import { PredefinedCommentsActivateDeactivateCommandComponent } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-list/components/commands/predefined-comments-activate-deactivate-command.component';
import { PredefinedComment } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/predefined-comments.model';
import { useActivateDeactivatePredefinedComment } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-list/hooks/use-activate-deactivate-predefined-comment.hook';
import { useTranslation } from 'core/i18n';
import { PredefinedCommentEditCommandComponent } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-list/components/commands/predefined-comment-edit-command.component';

export interface PredefinedCommentsInactiveRowOptionsComponentProps {
    predefinedComment: PredefinedComment;
}

export const PredefinedCommentsInactiveRowOptionsComponent = ({
    predefinedComment,
}: PredefinedCommentsInactiveRowOptionsComponentProps) => {
    const { t } = useTranslation();
    const { showActivateModal } = useActivateDeactivatePredefinedComment();

    return [
        <PredefinedCommentEditCommandComponent
            key={`predefined-comment-edit-option-${predefinedComment.id}`}
            commentId={predefinedComment.id}
        />,
        <PopoverMenuComponent
            key={`row-options-inactive-predefined-comment-${predefinedComment.id}`}
            anchor={`predefined-comments-inactive-row-options-${predefinedComment.id}`}
        >
            <PredefinedCommentsActivateDeactivateCommandComponent
                onClick={() => showActivateModal([predefinedComment])}
                text={t('settings.devices.predefined-comments.list.actions.activate')}
                iconName="circle_on_off"
            />
        </PopoverMenuComponent>,
    ];
};
